import TouchableRippleM from "@common/components/button/TouchableRippleM"
import TextM from "@common/components/text/TextM"
import { theme } from "@common/theme/theme"
import { FontAwesome5 } from "@expo/vector-icons"
import { LinearGradient } from "expo-linear-gradient"
import React from "react"
import { View } from "react-native"
import { ActivityIndicator } from "react-native-paper"

/**
 * Reusable "Create Activity" button with gradient style
 * Used in ProgressiveAnalysisDisplay and MaterialResultsCards
 */
const CreateActivityButton = ({
    onPress,
    loading = false,
    disabled = false,
    isCreated = false,
    style = {},
    label = "Créer l'activité",
    loadingLabel = "Création...",
    createdLabel = "Activité ajoutée",
}) => {
    // Already created state
    if (isCreated) {
        return (
            <View style={[{
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "center",
                paddingVertical: 14,
            }, style]}>
                <FontAwesome5 name="check" size={16} color={theme.colors.success} />
                <TextM color={theme.colors.success} fontWeight="Bold" style={{ marginLeft: 8 }}>
                    {createdLabel}
                </TextM>
            </View>
        )
    }

    return (
        <TouchableRippleM
            onPress={onPress}
            disabled={loading || disabled}
            style={[{
                borderRadius: 12,
                overflow: "hidden",
                opacity: (loading || disabled) ? 0.6 : 1,
            }, style]}
        >
            <LinearGradient
                colors={[
                    theme.colors.success,
                    theme.colors.successDark || theme.colors.success,
                ]}
                start={{ x: 0, y: 0 }}
                end={{ x: 1, y: 1 }}
                style={{
                    paddingVertical: 14,
                    paddingHorizontal: 20,
                    alignItems: "center",
                    flexDirection: "row",
                    justifyContent: "center",
                }}
            >
                {loading ? (
                    <ActivityIndicator size={16} color={theme.colors.white} style={{ marginRight: 8 }} />
                ) : (
                    <FontAwesome5 name="check-circle" size={16} color={theme.colors.white} style={{ marginRight: 8 }} />
                )}
                <TextM
                    fontSize={15}
                    fontWeight="Bold"
                    color={theme.colors.white}
                >
                    {loading ? loadingLabel : label}
                </TextM>
            </LinearGradient>
        </TouchableRippleM>
    )
}

export default CreateActivityButton
